import React, { useEffect } from "react";
import { useState } from "react";
import {
  Autocomplete,
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { getVegetablePrice } from "../../../redux/reducer/vegetablePrice/vegetablePriceReducer";
import { getData, postDataWithParams } from "../../../service/Service";
import { Settings } from "@mui/icons-material";
import NumberFormatting from "../../helper/NumberFormatting";
import {
  getPurchaseOrderCustById,
  postPurchaseOrderCust,
  purchaseOrderCustActions,
} from "../../../redux/reducer/purchaseOrderCust/purchaseOrderCustReducer";
import { getCustomer } from "../../../redux/reducer/customer/customerReducer";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    background: "#ddd",
    textAlign: "center",
    borderBottom: "1px solid #D1CDCD",
    padding: "1em",
  },
  tableCell: {
    background: "#ddd",
    borderBottom: "1px solid #D1CDCD",
    padding: "5px 0px",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

export default function AdminPurchaseOrderCustTambah() {
  // Navigate
  const navigate = useNavigate();

  // Styling
  const styles = useStyles();

  // Redux Data
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.dataToken);
  const customer = useSelector((state) => state.customer.data);

  // Local State
  const [formData, setFormData] = useState({
    purchaseOrderCode: "",
    customerId: "",
    totalPrice: 0,
    status: "",
  });
  const [vegetablePrice, setVegetablePrice] = useState([]);
  const [vegetablePriceSayuran, setVegetablePriceSayuran] = useState([]);
  const [vegetablePriceSayuranBuah, setVegetablePriceSayuranBuah] = useState(
    []
  );
  const [orderDetails, setOrderDetails] = useState([]);
  const [orderDetailsSayuranBuah, setOrderDetailsSayuranBuah] = useState([]);
  const [orderDetailsHerb, setOrderDetailsHerb] = useState([]);

  useEffect(() => {
    if (formData.customerId.length > 0) {
      if (orderDetails.length === 0) {
        handleAddOrderDetails();
        handleAddOrderDetailsSayuranBuah();
        handleAddOrderDetailsHerb();
      }
      let body = {};
      let params = {
        paginate: false,
      };
      postDataWithParams("/master/vegetable-price/search", token, body, params)
        .then((res) => {
          if (res.data.status === 200) {
            let custIndex = customer.docs.findIndex(
              (item) => item._id === formData.customerId
            );
            let customerType = res.data.data.docs.filter(
              (item) =>
                item.priceTypeId?._id ===
                customer.docs[custIndex].priceTypeId._id
            );

            let herbType = customerType.filter(
              (item) => item.vegetableTypeId.typeName === "herb"
            );
            let vegetableType = customerType.filter(
              (item) => item.vegetableTypeId.typeName === "vegetable"
            );
            let fruitVegetables = customerType.filter(
              (item) => item.vegetableTypeId.typeName === "fruit vegetable"
            );

            setVegetablePrice(herbType);
            setVegetablePriceSayuran(vegetableType);
            setVegetablePriceSayuranBuah(fruitVegetables);
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          toast.error(err.response.message);
        });
    }
  }, [formData.customerId]);

  // Basic Handle Change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    if (
      orderDetails.length > 0 &&
      orderDetailsHerb.length > 0 &&
      orderDetailsSayuranBuah.length > 0
    ) {
      setFormData({
        ...formData,
        totalPrice:
          (orderDetails[0].vegetablePriceId.length > 0
            ? orderDetails.reduce(
                (acc, cur) => parseInt(acc) + parseInt(cur.price),
                0
              )
            : 0) +
          (orderDetailsSayuranBuah[0].vegetablePriceId.length > 0
            ? orderDetailsSayuranBuah.reduce(
                (acc, cur) => parseInt(acc) + parseInt(cur.price),
                0
              )
            : 0) +
          (orderDetailsHerb[0].vegetablePriceId.length > 0
            ? orderDetailsHerb.reduce(
                (acc, cur) => parseInt(acc) + parseInt(cur.price),
                0
              )
            : 0),
      });
    }
  }, [
    orderDetails.length,
    orderDetailsSayuranBuah.length,
    orderDetailsHerb.length,
  ]);

  // Handling Order Details Sayuran
  const handleOrderDetails = (index) => (e) => {
    const newItems = [...orderDetails];
    newItems[index][e.target.name] = e.target.value;
    newItems[index]["totalOrder"] = newItems[index]["order"];
    if (autoCompleteValue[index]?._id) {
      newItems[index]["vegetablePriceId"] = autoCompleteValue[index]._id;
      newItems[index]["price"] =
        newItems[index]["totalOrder"] * autoCompleteValue[index].price;
      setFormData({
        ...formData,
        totalPrice:
          (orderDetailsHerb[0].vegetablePriceId.length > 0
            ? orderDetailsHerb.reduce(
                (acc, cur) => parseInt(acc) + parseInt(cur.price),
                0
              )
            : 0) +
          (orderDetailsSayuranBuah[0].vegetablePriceId.length > 0
            ? orderDetailsSayuranBuah.reduce(
                (acc, cur) => parseInt(acc) + parseInt(cur.price),
                0
              )
            : 0) +
          newItems.reduce((acc, cur) => parseInt(acc) + parseInt(cur.price), 0),
      });
    }
    setOrderDetails(newItems);
  };

  const handleAddOrderDetails = () => {
    setOrderDetails((prevItems) => [
      ...prevItems,
      {
        vegetablePriceId: "",
        order: 0,
        price: 0,
      },
    ]);
  };

  const handleDeleteOrderDetails = (value) => {
    let deletedData = [];
    for (let i = 0; i < orderDetails.length; i++) {
      if (i !== value) {
        deletedData.push(orderDetails[i]);
      }
    }
    setOrderDetails(deletedData);
  };

  // Handling Order Details Sayuran Buah
  const handleOrderDetailsSayuranBuah = (index) => (e) => {
    const newItems = [...orderDetailsSayuranBuah];
    newItems[index][e.target.name] = e.target.value;
    newItems[index]["totalOrder"] = newItems[index]["order"];

    if (autoCompleteValueSayuranBuah[index]?._id) {
      newItems[index]["vegetablePriceId"] =
        autoCompleteValueSayuranBuah[index]._id;
      newItems[index]["price"] =
        newItems[index]["totalOrder"] *
        autoCompleteValueSayuranBuah[index].price;
      setFormData({
        ...formData,
        totalPrice:
          (orderDetailsHerb[0].vegetablePriceId.length > 0
            ? orderDetailsHerb.reduce(
                (acc, cur) => parseInt(acc) + parseInt(cur.price),
                0
              )
            : 0) +
          (orderDetails[0].vegetablePriceId.length > 0
            ? orderDetails.reduce(
                (acc, cur) => parseInt(acc) + parseInt(cur.price),
                0
              )
            : 0) +
          newItems.reduce((acc, cur) => parseInt(acc) + parseInt(cur.price), 0),
      });
    }
    setOrderDetailsSayuranBuah(newItems);
  };

  const handleAddOrderDetailsSayuranBuah = () => {
    setOrderDetailsSayuranBuah((prevItems) => [
      ...prevItems,
      {
        vegetablePriceId: "",
        order: 0,
        price: 0,
      },
    ]);
  };

  const handleDeleteOrderDetailsSayuranBuah = (value) => {
    let deletedData = [];
    for (let i = 0; i < orderDetailsSayuranBuah.length; i++) {
      if (i !== value) {
        deletedData.push(orderDetailsSayuranBuah[i]);
      }
    }
    setOrderDetailsSayuranBuah(deletedData);
  };

  // Handling Order Details Herb
  const handleOrderDetailsHerb = (index) => (e) => {
    const newItems = [...orderDetailsHerb];
    newItems[index][e.target.name] = e.target.value;
    newItems[index]["totalOrder"] = newItems[index]["order"];

    if (autoCompleteValueHerb[index]?._id) {
      newItems[index]["vegetablePriceId"] = autoCompleteValueHerb[index]._id;
      newItems[index]["price"] =
        newItems[index]["totalOrder"] * autoCompleteValueHerb[index].price;
      setFormData({
        ...formData,
        totalPrice:
          (orderDetails[0].vegetablePriceId.length > 0
            ? orderDetails.reduce(
                (acc, cur) => parseInt(acc) + parseInt(cur.price),
                0
              )
            : 0) +
          (orderDetailsSayuranBuah[0].vegetablePriceId.length > 0
            ? orderDetailsSayuranBuah.reduce(
                (acc, cur) => parseInt(acc) + parseInt(cur.price),
                0
              )
            : 0) +
          newItems.reduce((acc, cur) => parseInt(acc) + parseInt(cur.price), 0),
      });
    }
    setOrderDetailsHerb(newItems);
  };

  const handleAddOrderDetailsHerb = () => {
    setOrderDetailsHerb((prevItems) => [
      ...prevItems,
      {
        vegetablePriceId: "",
        order: 0,
        price: 0,
      },
    ]);
  };

  const handleDeleteOrderDetailsHerb = (value) => {
    let deletedData = [];
    for (let i = 0; i < orderDetailsHerb.length; i++) {
      if (i !== value) {
        deletedData.push(orderDetailsHerb[i]);
      }
    }
    setOrderDetailsHerb(deletedData);
  };

  const handleSubmitAll = (e) => {
    e.preventDefault();
    Swal.fire({
      title: `Mohon dicek kembali data yang akan di input`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        let orderDetailsCombined = [
          ...orderDetails.filter((item) => item.vegetablePriceId.length > 0),
          ...orderDetailsSayuranBuah.filter(
            (item) => item.vegetablePriceId.length > 0
          ),
          ...orderDetailsHerb.filter(
            (item) => item.vegetablePriceId.length > 0
          ),
        ];
        if (orderDetailsCombined.length > 0) {
          let data = {
            data: {
              purchaseOrderCode: formData.purchaseOrderCode,
              customerId: formData.customerId,
              orderDetails: orderDetailsCombined,
              totalPrices: formData.totalPrice,
              status: 1,
              createdBy: user.username,
              updatedBy: user.username,
            },
            token: token,
          };
          dispatch(postPurchaseOrderCust(data)).then((res) => {
            if (res.payload.status === 201) {
              let dataGetById = {
                id: res.payload.data._id,
                token: token,
              };
              dispatch(getPurchaseOrderCustById(dataGetById)).then((result) => {
                dispatch(
                  purchaseOrderCustActions.addPurchaseOrderCust(
                    result.payload.data
                  )
                );
                toast.success(res.payload.message);
                navigate("/admin/po-toko");
              });
            } else {
              toast.error("Mohon isi data anda dengan benar");
            }
          });
        } else {
          toast.error("Mohon isi data anda dengan benar");
        }
      } else {
        return;
      }
    });
  };

  const loadMore = (value) => (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop < 300 &&
      event.target.scrollTop < 100
    ) {
      if (customer.totalDocs !== customer.docs.length && value === 1) {
        const getData = {
          params: {
            limit: customer.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getCustomer(getData));
      } else if (
        vegetablePrice.totalDocs !== vegetablePrice.docs.length &&
        value === 2
      ) {
        const getData = {
          params: {
            limit: vegetablePrice.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getVegetablePrice(getData));
      }
    }
  };

  const orderDetailsColumn = ["SAYURAN", "ORDER", "HARGA", "AKSI"];

  const handleGenerateCode = () => {
    getData("/admin/purchase-order/generate-code", token, null)
      .then((res) => {
        setFormData({
          ...formData,
          purchaseOrderCode: res.data.data,
        });
        toast.success(res.data.message);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  };

  const [autoCompleteValue, setAutoCompleteValue] = useState([]);
  const [autoCompleteValueSayuranBuah, setAutoCompleteValueSayuranBuah] =
    useState([]);
  const [autoCompleteValueHerb, setAutoCompleteValueHerb] = useState([]);

  const handleVegetablePrice = (e, index) => {
    let tempVegetablePrice = [...autoCompleteValue];
    tempVegetablePrice[index] =
      e !== null
        ? e
        : {
            _id: "",
            price: 0,
          };
    setAutoCompleteValue(tempVegetablePrice);
    const newItems = [...orderDetails];
    newItems[index]["totalOrder"] = newItems[index]["order"];
    newItems[index]["vegetablePriceId"] = tempVegetablePrice[index]._id;
    newItems[index]["price"] =
      newItems[index]["totalOrder"] * tempVegetablePrice[index].price;
    setFormData({
      ...formData,
      totalPrice:
        (orderDetails[0].vegetablePriceId.length > 0
          ? orderDetails.reduce(
              (acc, cur) => parseInt(acc) + parseInt(cur.price),
              0
            )
          : 0) +
        (orderDetailsSayuranBuah[0].vegetablePriceId.length > 0
          ? orderDetailsSayuranBuah.reduce(
              (acc, cur) => parseInt(acc) + parseInt(cur.price),
              0
            )
          : 0) +
        newItems.reduce((acc, cur) => parseInt(acc) + parseInt(cur.price), 0),
    });
    setOrderDetails(newItems);
  };

  const handleVegetablePriceSayuranBuah = (e, index) => {
    let tempVegetablePrice = [...autoCompleteValueSayuranBuah];
    tempVegetablePrice[index] =
      e !== null
        ? e
        : {
            _id: "",
            price: 0,
          };
    setAutoCompleteValueSayuranBuah(tempVegetablePrice);
    const newItems = [...orderDetailsSayuranBuah];
    newItems[index]["totalOrder"] = newItems[index]["order"];
    newItems[index]["vegetablePriceId"] = tempVegetablePrice[index]._id;
    newItems[index]["price"] =
      newItems[index]["totalOrder"] * tempVegetablePrice[index].price;
    setFormData({
      ...formData,
      totalPrice:
        (orderDetails[0].vegetablePriceId.length > 0
          ? orderDetails.reduce(
              (acc, cur) => parseInt(acc) + parseInt(cur.price),
              0
            )
          : 0) +
        (orderDetailsHerb[0].vegetablePriceId.length > 0
          ? orderDetailsHerb.reduce(
              (acc, cur) => parseInt(acc) + parseInt(cur.price),
              0
            )
          : 0) +
        newItems.reduce((acc, cur) => parseInt(acc) + parseInt(cur.price), 0),
    });
    setOrderDetailsSayuranBuah(newItems);
  };

  const handleVegetablePriceHerb = (e, index) => {
    let tempVegetablePrice = [...autoCompleteValueHerb];
    tempVegetablePrice[index] =
      e !== null
        ? e
        : {
            _id: "",
            price: 0,
          };
    setAutoCompleteValueHerb(tempVegetablePrice);
    const newItems = [...orderDetailsHerb];
    newItems[index]["totalOrder"] = newItems[index]["order"];
    newItems[index]["vegetablePriceId"] = tempVegetablePrice[index]._id;
    newItems[index]["price"] =
      newItems[index]["totalOrder"] * tempVegetablePrice[index].price;
    setFormData({
      ...formData,
      totalPrice:
        (orderDetails[0].vegetablePriceId.length > 0
          ? orderDetails.reduce(
              (acc, cur) => parseInt(acc) + parseInt(cur.price),
              0
            )
          : 0) +
        (orderDetailsSayuranBuah[0].vegetablePriceId.length > 0
          ? orderDetailsSayuranBuah.reduce(
              (acc, cur) => parseInt(acc) + parseInt(cur.price),
              0
            )
          : 0) +
        newItems.reduce((acc, cur) => parseInt(acc) + parseInt(cur.price), 0),
    });
    setOrderDetailsHerb(newItems);
  };

  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          BUAT PO TOKO
        </Typography>
      </Card>
      <Card className={styles.headerClass}>
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginTop: "10px",
          }}
          onSubmit={handleSubmitAll}
        >
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              KODE NOTA TOKO
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ maxLength: 20, style: { background: "white" } }}
              required
              helperText={
                formData.purchaseOrderCode.length > 0
                  ? /^[A-Za-z]{2}-\d{5}/.test(formData.purchaseOrderCode)
                    ? ""
                    : "*Format Kode Petani salah"
                  : ""
              }
              size="small"
              error={
                formData.purchaseOrderCode.length > 0
                  ? /^[A-Za-z]{2}-\d{5}/.test(formData.purchaseOrderCode)
                    ? false
                    : true
                  : false
              }
              name="purchaseOrderCode"
              onChange={handleChange}
              value={formData.purchaseOrderCode}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
            <Button
              size="small"
              variant="contained"
              onClick={() => handleGenerateCode()}
            >
              <Settings />
            </Button>
          </FormControl>
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              CUSTOMER
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              error={false}
              name="customerId"
              onChange={handleChange}
              value={formData.customerId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(1),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {customer.docs.length > 0 ? (
                customer.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.customerName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>
          <Divider />
          <Typography
            marginTop={1}
            marginBottom={1}
            fontSize={14}
            color={"#2e473f"}
            variant="h6"
          >
            ORDER DETAIL - Kategori Sayuran
          </Typography>
          <table
            style={{
              width: "100%",
              marginBottom: "10px",
              borderCollapse: "collapse",
              borderRadius: "1em",
              overflow: "hidden",
            }}
          >
            <thead>
              {orderDetailsColumn.map((item, index) => {
                return (
                  <td className={styles.tableHeader} key={index}>
                    {item}
                  </td>
                );
              })}
            </thead>
            <tbody>
              {orderDetails.length > 0 &&
                orderDetails.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td
                        className={styles.tableCell}
                        style={{ width: "400px" }}
                      >
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <Autocomplete
                            id="auto-complete"
                            autoComplete
                            fullWidth
                            required
                            value={autoCompleteValue[index]}
                            onChange={(event, newValue) => {
                              handleVegetablePrice(newValue, index);
                            }}
                            options={vegetablePriceSayuran}
                            getOptionLabel={(option) =>
                              `${option.vegetableName} - ${option.unitWeight.unitWeightId.unitName}`
                            }
                            includeInputInList
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                InputLabelProps={{ shrink: true }}
                                size="small"
                                name="vegetablePriceId"
                                style={{
                                  maxWidth: "400px",
                                  background: "white",
                                  marginRight: "10px",
                                }}
                              />
                            )}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            required
                            size="small"
                            InputProps={{
                              inputComponent: NumberFormatting,
                              endAdornment: (
                                <InputAdornment position="end"></InputAdornment>
                              ),
                            }}
                            error={false}
                            name="order"
                            id={index}
                            onChange={handleOrderDetails(index)}
                            value={item.order}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ readOnly: true }}
                            required
                            size="small"
                            error={false}
                            name="price"
                            id={index}
                            onChange={handleOrderDetails(index)}
                            value={item.price.toLocaleString("id", {
                              style: "currency",
                              currency: "IDR",
                            })}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "auto",
                            width: "100px",
                          }}
                        >
                          <AddIcon
                            className={styles.actionButtonEdit}
                            onClick={() => handleAddOrderDetails()}
                          />
                          {orderDetails.length > 1 && index !== 0 ? (
                            <RemoveIcon
                              className={styles.actionButtonEdit}
                              onClick={() => handleDeleteOrderDetails(index)}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          <Divider />
          <Typography
            marginTop={1}
            marginBottom={1}
            fontSize={14}
            color={"#2e473f"}
            variant="h6"
          >
            ORDER DETAIL - Kategori Sayuran Buah
          </Typography>
          <table
            style={{
              width: "100%",
              marginBottom: "10px",
              borderCollapse: "collapse",
              borderRadius: "1em",
              overflow: "hidden",
            }}
          >
            <thead>
              {orderDetailsColumn.map((item, index) => {
                return (
                  <td className={styles.tableHeader} key={index}>
                    {item}
                  </td>
                );
              })}
            </thead>
            <tbody>
              {orderDetailsSayuranBuah.length > 0 &&
                orderDetailsSayuranBuah.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td
                        className={styles.tableCell}
                        style={{ width: "400px" }}
                      >
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <Autocomplete
                            id="auto-complete"
                            autoComplete
                            fullWidth
                            required
                            value={autoCompleteValue[index]}
                            onChange={(event, newValue) => {
                              handleVegetablePriceSayuranBuah(newValue, index);
                            }}
                            options={vegetablePriceSayuranBuah}
                            getOptionLabel={(option) =>
                              `${option.vegetableName} - ${option.unitWeight.unitWeightId.unitName}`
                            }
                            includeInputInList
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                InputLabelProps={{ shrink: true }}
                                size="small"
                                name="vegetablePriceId"
                                style={{
                                  maxWidth: "400px",
                                  background: "white",
                                  marginRight: "10px",
                                }}
                              />
                            )}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            required
                            size="small"
                            InputProps={{
                              inputComponent: NumberFormatting,
                              endAdornment: (
                                <InputAdornment position="end"></InputAdornment>
                              ),
                            }}
                            error={false}
                            name="order"
                            id={index}
                            onChange={handleOrderDetailsSayuranBuah(index)}
                            value={item.order}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ readOnly: true }}
                            required
                            size="small"
                            error={false}
                            name="price"
                            id={index}
                            onChange={handleOrderDetailsSayuranBuah(index)}
                            value={item.price.toLocaleString("id", {
                              style: "currency",
                              currency: "IDR",
                            })}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "auto",
                            width: "100px",
                          }}
                        >
                          <AddIcon
                            className={styles.actionButtonEdit}
                            onClick={() => handleAddOrderDetailsSayuranBuah()}
                          />
                          {orderDetailsSayuranBuah.length > 1 && index !== 0 ? (
                            <RemoveIcon
                              className={styles.actionButtonEdit}
                              onClick={() =>
                                handleDeleteOrderDetailsSayuranBuah(index)
                              }
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          <Divider />
          <Typography
            marginTop={1}
            marginBottom={1}
            fontSize={14}
            color={"#2e473f"}
            variant="h6"
          >
            ORDER DETAIL - Kategori Herb
          </Typography>
          <table
            style={{
              width: "100%",
              marginBottom: "10px",
              borderCollapse: "collapse",
              borderRadius: "1em",
              overflow: "hidden",
            }}
          >
            <thead>
              {orderDetailsColumn.map((item, index) => {
                return (
                  <td className={styles.tableHeader} key={index}>
                    {item}
                  </td>
                );
              })}
            </thead>
            <tbody>
              {orderDetailsHerb.length > 0 &&
                orderDetailsHerb.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td
                        className={styles.tableCell}
                        style={{ width: "400px" }}
                      >
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <Autocomplete
                            id="auto-complete"
                            autoComplete
                            fullWidth
                            required
                            value={autoCompleteValue[index]}
                            onChange={(event, newValue) => {
                              handleVegetablePriceHerb(newValue, index);
                            }}
                            options={vegetablePrice}
                            getOptionLabel={(option) =>
                              `${option.vegetableName} - ${option.unitWeight.unitWeightId.unitName}`
                            }
                            includeInputInList
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                InputLabelProps={{ shrink: true }}
                                size="small"
                                name="vegetablePriceId"
                                style={{
                                  maxWidth: "400px",
                                  background: "white",
                                  marginRight: "10px",
                                }}
                              />
                            )}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            required
                            size="small"
                            InputProps={{
                              inputComponent: NumberFormatting,
                              endAdornment: (
                                <InputAdornment position="end"></InputAdornment>
                              ),
                            }}
                            error={false}
                            name="order"
                            id={index}
                            onChange={handleOrderDetailsHerb(index)}
                            value={item.order}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ readOnly: true }}
                            required
                            size="small"
                            error={false}
                            name="price"
                            id={index}
                            onChange={handleOrderDetailsHerb(index)}
                            value={item.price.toLocaleString("id", {
                              style: "currency",
                              currency: "IDR",
                            })}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "auto",
                            width: "100px",
                          }}
                        >
                          <AddIcon
                            className={styles.actionButtonEdit}
                            onClick={() => handleAddOrderDetailsHerb()}
                          />
                          {orderDetailsHerb.length > 1 && index !== 0 ? (
                            <RemoveIcon
                              className={styles.actionButtonEdit}
                              onClick={() =>
                                handleDeleteOrderDetailsHerb(index)
                              }
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          <Divider />

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TOTAL HARGA
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true, style: { background: "white" } }}
              required
              size="small"
              error={false}
              name="totalPrice"
              onChange={handleChange}
              value={formData.totalPrice.toLocaleString("id", {
                style: "currency",
                currency: "IDR",
              })}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <div className={styles.footerButton}>
            <Button variant="contained" type="submit">
              SUBMIT
            </Button>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: "10px" }}
              onClick={() => navigate("/admin/po-toko")}
            >
              KEMBALI
            </Button>
          </div>
        </form>
      </Card>
    </Grid>
  );
}
